<div class="page">
  <valg-dk-header></valg-dk-header>
  <main class="page-content">
    <router-outlet></router-outlet>
  </main>
  <valg-footer leftPaneTitleKey="footer.title" [informationWidth]="5" [leftPaneContent]="['footer.description', 'footer.platform_responsible_description']" [links]="footerLinks"></valg-footer>
</div>
